<!-- https://app.swaggerhub.com/apis/pdn-mx/s1-Declaraciones-Inicial/2.0#/adeudosPasivos
https://github.com/hemansr/elsalto_portal_app/wiki/adeudosPasivos  -->
<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />
    <b-row>
      <!--GEMERAL-->
      <b-col sm="12">
        <h4 style="text-align: center">
          13. ADEUDOS DEL DECLARANTE, CÓNYUGE, CONCUBINA O CONCUBINARIO Y/O
          DEPENDIENTES ECONÓMICOS (SITUACIÓN ACTUAL)
        </h4>
      </b-col>

      <!--LISTA DE BIENES-->
      <b-list-group sm="12">
        <b-list-group-item v-for="(item, index) in adeudo" :key="index">
          <b-col md="12">
            <div class="customHr">.</div>
          </b-col>
          <b-col md="12">
            <h5 style="text-align: center">Adeudos</h5>
          </b-col>
          <b-col md="12">
            <div class="customHr">.</div>
          </b-col>

          <!-- Formulario -->
          <b-col md="12">
            <b-row>
              <b-col sm="3">
                <b-form-group>
                  <label>Tipo Operación:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="cambiosAdeudo[index].cambios = true"
                    v-model="item.tipoOperacion"
                    :options="tipoOperacion"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group>
                  <label>Tipo Adeudo:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    v-model="item.tipoAdeudo.clave"
                    :options="tipoAdeudo"
                    text-field="valor"
                    value-field="clave"
                    @change="seleccionaValorTipo(index)"
                  />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group>
                  <label>Numero de Cuenta Contrato:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosAdeudo[index].cambios = true"
                    type="text"
                    v-model="item.numeroCuentaContrato"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group label="Fecha adquisición:">
                  <datetime
                    :disabled="status === 'Concluida'"
                    @change="cambiosAdeudo[index].cambios = true"
                    id="adquision"
                    :input-class="'form-control input'"
                    v-model="item.fechaAdquisicion"
                    type="date"
                  />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group>
                  <label>Monto Original Valor:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosAdeudo[index].cambios = true"
                    type="text"
                    v-model="item.montoOriginal.valor"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="1">
                <b-form-group>
                  <label>País:</label>
                  <b-form-input
                    type="text"
                    v-model="item.localizacionAdeudo.pais"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="12">
                <h6 style="text-align: center">Otorgante</h6>
              </b-col>

              <b-col sm="3">
                <b-form-group>
                  <label>Tipo Persona:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="cambiosAdeudo[index].cambios = true"
                    v-model="item.otorganteCredito.tipoPersona"
                    :options="tipoPersona"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group>
                  <label>Nombre Institución:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosAdeudo[index].cambios = true"
                    type="text"
                    v-model="item.otorganteCredito.nombreInstitucion"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group>
                  <label>RFC:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosAdeudo[index].cambios = true"
                    type="text"
                    v-model="item.otorganteCredito.rfc"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <!--En caso de ser INICIAL  -->

              <b-col sm="12">
                <b-row v-if="banderaTipo === 'INICIAL'">
                  <b-col md="3">
                    <b-form-group>
                      <label>Monto Original Valor:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosAdeudo[index].cambios = true"
                        type="text"
                        v-model="item.saldoInsolutoSituacionActual.valor"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col md="1">
                    <b-form-group>
                      <label>Moneda:</label>
                      <b-form-input
                        type="text"
                        v-model="item.saldoInsolutoSituacionActual.moneda"
                        disabled
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <!--FIN INICIAL -->

              <!--En caso de ser MODIFICACION a -->
              <b-col sm="12">
                <b-row v-if="banderaTipo === 'MODIFICACION'">
                  <b-col md="3">
                    <b-form-group>
                      <label>Saldo Insoluto Diciembre Anterior:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosAdeudo[index].cambios = true"
                        type="text"
                        v-model="item.saldoInsolutoDiciembreAnterior.valor"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group>
                      <label>Moneda:</label>
                      <b-form-input
                        type="text"
                        v-model="item.saldoInsolutoDiciembreAnterior.moneda"
                        disabled
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>

              <!-- En caso de ser CONCLUSION  -->
              <b-col sm="12">
                <b-row v-if="banderaTipo === 'CONCLUSION'">
                  <b-col md="3">
                    <b-form-group>
                      <label>Saldo Insoluto Fecha:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        @change="cambiosAdeudo[index].cambios = true"
                        type="text"
                        v-model="item.saldoInsolutoFechaConclusion.valor"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group>
                      <label>Saldo Insoluto Moneda:</label>
                      <b-form-input
                        @change="cambiosAdeudo[index].cambios = true"
                        type="text"
                        v-model="item.saldoInsolutoFechaConclusion.moneda"
                        disabled
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <br />
          <!-- FIN formulario -->
          <br />
          <hr />

          <!-- Titular -->
          <b-col md="12">
           
            <b-col md="12">
              <h6>Titulares:</h6>
            </b-col>

            <b-list-group sm="12">
              <b-list-group-item
                v-for="(item_titular, i) in adeudo[index].titular"
                :key="i"
              >
                <p style="text-align: center">{{ item_titular.valor }}</p>
                <b-row style="text-align: center">
                  <b-col>
                    <b-button
                    v-if="status !== 'Concluida'"
                      variant="danger"
                      size="sm"
                      @click="eliminarTitular(index)"
                      >Eliminar titular</b-button
                    >
                  </b-col>
                </b-row>
              </b-list-group-item>
              <br />
              <b-modal
              :disabled="status === 'Concluida'"
                v-model="mostrar"
                title="Nuevo titular"
                cancel-title="Cancelar"
                ok-title="Generar"
                @ok="agregarTitular(index)"
              >
                <b-form-select
                  v-model="tmpTitular"
                  :options="t"
                ></b-form-select>
              </b-modal>
            </b-list-group>
           
            <b-col md="12">
              <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="mostrar = true"
                >Agregar Titular</b-button
              >
            </b-col>
          
          </b-col>

          <!-- FIN titular -->
          <br />
        
          <!-- TERCERO -->
          <b-col md="12">
            <b-col md="12">
              <h6>Terceros:</h6>
            </b-col>
            <b-list-group sm="12">
              <b-list-group-item
                v-for="(item_tercero, i) in adeudo[index].tercero"
                :key="i"
              >
                <b-row>
                  <b-col sm="4">
                    <b-form-group>
                      <label>Tipo de Persona:</label>
                      <b-form-select
                      :disabled="status === 'Concluida'"
                        v-model="item_tercero.tipoPersona"
                        :options="tipoPersona"
                        class="mb-3"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <label>Nombre razón social:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        type="text"
                        v-model="item_tercero.nombreRazonSocial"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <label>RFC:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        type="text"
                        v-model="item_tercero.rfc"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row style="text-align: center">
                  <b-col>
                    <b-button
                    v-if="status !== 'Concluida'"
                      variant="primary"
                      size="sm"
                      @click="tercero(item_tercero._id, index, i)"
                      >Guardar</b-button
                    >
                  </b-col>
                  <br />
                 

                  <b-col>
                    <b-button
                    v-if="status !== 'Concluida'"
                      variant="danger"
                      size="sm"
                      @click="eliminarTercero(index, i)"
                      >Eliminar Tercero</b-button
                    >
                  </b-col>
                </b-row>
              </b-list-group-item>
              <br />
              <b-row>
                <b-col md="6">
                  <b-button
                  v-if="status !== 'Concluida'"
                    variant="primary"
                    size="sm"
                    @click="agregarTercero(index)"
                    >Agregar tercero</b-button
                  >
                </b-col>
              </b-row>
            </b-list-group>
          </b-col>
          <!-- FIN tercero -->
          <br />
          <hr />
          <b-col md="12">
            <b-row style="text-align: center">
              <b-col>
                <b-button
                v-if="status !== 'Concluida'"
                  variant="primary"
                  size="sm"
                  @click="guardarAdeudo(index)"
                  >Guardar</b-button
                >
                <br />
                <p v-if="cambiosAdeudo[index].cambios" class="error-text">
                  <i>No se han guardado los cambios</i>
                </p>
              </b-col>

              <b-col>
                <b-button
                v-if="status !== 'Concluida'"
                  variant="danger"
                  size="sm"
                  @click="eliminarAdeudo(index)"
                  >Eliminar Adeudo</b-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-list-group-item>
      </b-list-group>
    </b-row>
    <br />
    <b-row>
      <b-col md="12">
        <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="nuevoAdeudo()"
          >Agregar Adeudo</b-button
        >
      </b-col>
    </b-row>
    <br />

    <!--ACLARACIONES-->
    <b-row>
      <b-col md="12">
        <b-form-group>
          <label>Aclaraciones observaciones:</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            type="text"
            @change="cambios = true"
            v-model="adeudos.aclaracionesObservaciones"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <br />
    <br />
    <b-row>
      <b-col md="4">
        <b-button variant="success" @click="verSeccion(0)" :disabled="enviando"
          >Regresar al índice</b-button
        >
      </b-col>
      <b-col md="4" style="text-align: center">
      <b-button
      v-if="status !== 'Concluida'"
        variant="primary"
        @click="actualizarObservaciones()"
        :disabled="enviando"
        >Guardar cambios</b-button
      >
      <br />
      <p v-if="cambios" class="error-text">
        <i>No se han guardado los cambios</i>
      </p>
      </b-col>
      <b-col md="2" >
        <b-button
          variant="secondary"
          @click="verSeccion(12)"
          :disabled="enviando"
          >Anterior</b-button
        >
      </b-col>
      <b-col md="2">
        <b-button
        
          class="pull-right"
          variant="secondary"
          @click="verSeccion(14)"
          :disabled="enviando"
          >Siguiente</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  components: { Loader, Datetime },
  props: ["adeudos", "tipo", "status"],
  computed: {
    ...mapGetters(["httpURL", "sessionToken"])
  },
  data: function() {
    return {
      contadorTercero: 0,
      titulo: this.$route.name,
      contador: 0,
      banderaTipo: this.tipo,
      adeudo: [{}],
      enviando: false,
      cambios: false,
      cambiosAdeudo: [{}],
      tipoOperacion: ["AGREGAR", "MODIFICAR", "SIN_CAMBIOS", "BAJA"],
      banderaEditar: false,
      formaPago: [
        { clave: "CREDITO", valor: "CRÉDITO" },
        { clave: "CONTADO", valor: "CONTADO" },
        { clave: "NO_APLICA", valor: "NO APLICA" }
      ],
      tipoAdeudo: [
        { clave: "CHIP", valor: "CRÉDITO HIPOTECARIO" },
        { clave: "CAUT", valor: "CRÉDITO AUTOMOTRIZ" },
        { clave: "CPER", valor: "CRÉDITO PERSONAL" },
        { clave: "TCRN", valor: "TARJETA DE CRÉDITO BANCARIA" },
        { clave: "TCRD", valor: "TARJETA DE CRÉDITO DEPARTAMENTAL" },
        { clave: "PRPE", valor: "PRÉSTAMO PERSONAL" },
        { clave: "OTRO", valor: "OTRO" }
      ],
      formaAdquisicion: [
        { clave: "CPV", valor: "COMPRAVENTA" },
        { clave: "CSN", valor: "CESIÓN" },
        { clave: "DNC", valor: "DONACIÓN" },
        { clave: "HRN", valor: "HERENCIA" },
        { clave: "PRM", valor: "PERMUTA" },
        { clave: "RST", valor: "RIFA O SORTEO" },
        { clave: "STC", valor: "SENTENCIA" }
      ],
      tipoPersona: ["FISICA", "MORAL"],
      tmpTitular: "",
      mostrar: false,
      t: [
        "DECLARANTE",
        "CONYUGE",
        "CONCUBINA O CONCUBINARIO",
        "CONVIVIENTE",
        "DEPENDIENTE ECONÓMICO",
        "COPROPIEDAD CON TERCEROS"
      ],

      titular: [
        { clave: "DEC", valor: "DECLARANTE" },
        { clave: "CYG", valor: "CONYUGE" },
        { clave: "CBN", valor: "CONCUBINA O CONCUBINARIO" },
        { clave: "CVV", valor: "CONVIVIENTE" },
        { clave: "DEN", valor: "DEPENDIENTE ECONÓMICO" },
        { clave: "CTER", valor: "COPROPIEDAD CON TERCEROS" }
      ]
    };
  },
  methods: {
    nuevoAdeudo() {
      axios
        .post(
          this.httpURL +
            "/declaraciones/V2/adeudosPasivos/" +
            this.$route.params.id +
            "/adeudo",
          {},
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
         
          let objeto = { _id: this.contador, cambios: false };
          this.cambiosAdeudo.push(objeto);
          this.adeudo.push(res.data.adeudo);
          this.contador++;
          this.enviando = true;
          this.$notify({
            group: "foo",
            type: "success",
            duration: 2500,
            speed: 1000,
            text: res.data.mensaje
          });
          this.enviando = false;
        })
        .catch(error => {
          if (error.response) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: error.response.data.mensaje
            });
          } else if (error.request) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo establecer una conexión al servidor."
            });
          }
          this.enviando = false;
        });
    },
    // llenaEspacios(index) {
    //   if (this.banderaTipoOperacion === "AGREGAR") {
    //     this.adeudo[index].saldoInsolutoDiciembreAnterior.valor = "";
    //     this.adeudo[index].saldoInsolutoDiciembreAnterior.moneda = "";
    //     this.adeudo[index].saldoInsolutoFechaConclusion.valor = "";
    //     this.adeudo[index].saldoInsolutoFechaConclusion.moneda = "";
    //   } else if (this.banderaTipoOperacion === "MODIFICAR") {
    //     this.adeudo[index].saldoInsolutoSituacionActual.valor = "";
    //     this.adeudo[index].saldoInsolutoSituacionActual.moneda = "";
    //     this.adeudo[index].saldoInsolutoFechaConclusion.valor = "";
    //     this.adeudo[index].saldoInsolutoFechaConclusion.moneda = "";
    //   } else if (this.banderaTipoOperacion === "CONCLUSION") {
    //     this.adeudo[index].saldoInsolutoSituacionActual.valor = "";
    //     this.adeudo[index].saldoInsolutoSituacionActual.moneda = "";
    //     this.adeudo[index].saldoInsolutoDiciembreAnterior.valor = "";
    //     this.adeudo[index].saldoInsolutoDiciembreAnterior.moneda = "";
    //   }
    // },
    guardarAdeudo(index) {
      this.enviando = true;
      if (this.tipo === "INICIAL") {
        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/adeudosPasivos/" +
              this.$route.params.id +
              "/adeudo/" +
              this.adeudos.adeudo[index]._id,

            {
              tipoOperacion: this.adeudo[index].tipoOperacion,
              tipoAdeudoClave: this.adeudo[index].tipoAdeudo.clave,
              tipoAdeudoValor: this.adeudo[index].tipoAdeudo.valor,
              numeroCuentaContrato: this.adeudo[index].numeroCuentaContrato,
              fechaAdquisicion: this.adeudo[index].fechaAdquisicion,
              montoOriginalValor: this.adeudo[index].montoOriginal.valor,
              montoOriginalMoneda: this.adeudo[index].montoOriginal.moneda,
              otorganteTipoPersona: this.adeudo[index].otorganteCredito
                .tipoPersona,
              otorganteNombreInstitucion: this.adeudo[index].otorganteCredito
                .nombreInstitucion,
              otorganteRFC: this.adeudo[index].otorganteCredito.rfc,
              localizacionPais: this.adeudo[index].localizacionAdeudo.pais,
              //INICIAL
              saldoInsolutoSituacionActualValor: this.adeudo[index]
                .saldoInsolutoSituacionActual.valor,
              saldoInsolutoSituacionActualMoneda: this.adeudo[index]
                .saldoInsolutoSituacionActual.moneda
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
          
          

           
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
              this.cambiosAdeudo[index].cambios = false;
            }
            this.enviando = false;
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo guardar la sección."
            });
            this.enviando = false;
          });
      } else if (this.tipo === "MODIFICACION") {
        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/adeudosPasivos/" +
              this.$route.params.id +
              "/adeudo/" +
              this.adeudos.adeudo[index]._id,

            {
              tipoOperacion: this.adeudo[index].tipoOperacion,
              tipoAdeudoClave: this.adeudo[index].tipoAdeudo.clave,
              tipoAdeudoValor: this.adeudo[index].tipoAdeudo.valor,
              numeroCuentaContrato: this.adeudo[index].numeroCuentaContrato,
              fechaAdquisicion: this.adeudo[index].fechaAdquisicion,
              montoOriginalValor: this.adeudo[index].montoOriginal.valor,
              montoOriginalMoneda: this.adeudo[index].montoOriginal.moneda,
              otorganteTipoPersona: this.adeudo[index].otorganteCredito
                .tipoPersona,
              otorganteNombreInstitucion: this.adeudo[index].otorganteCredito
                .nombreInstitucion,
              otorganteRFC: this.adeudo[index].otorganteCredito.rfc,
              localizacionPais: this.adeudo[index].localizacionAdeudo.pais,
              //MODIFICACION
              saldoInsolutoDiciembreAnteriorValor: this.adeudo[index]
                .saldoInsolutoDiciembreAnterior.valor,
              saldoInsolutoDiciembreAnteriorMoneda: this.adeudo[index]
                .saldoInsolutoDiciembreAnterior.moneda
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
           
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
              this.cambiosAdeudo[index].cambios = false;
            }
            this.enviando = false;
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo guardar la sección."
            });
            this.enviando = false;
          });
      } else if (this.tipo === "CONCLUSION") {
        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/adeudosPasivos/" +
              this.$route.params.id +
              "/adeudo/" +
              this.adeudos.adeudo[index]._id,

            {
              tipoOperacion: this.adeudo[index].tipoOperacion,
              tipoAdeudoClave: this.adeudo[index].tipoAdeudo.clave,
              tipoAdeudoValor: this.adeudo[index].tipoAdeudo.valor,
              numeroCuentaContrato: this.adeudo[index].numeroCuentaContrato,
              fechaAdquisicion: this.adeudo[index].fechaAdquisicion,
              montoOriginalValor: this.adeudo[index].montoOriginal.valor,
              montoOriginalMoneda: this.adeudo[index].montoOriginal.moneda,
              otorganteTipoPersona: this.adeudo[index].otorganteCredito
                .tipoPersona,
              otorganteNombreInstitucion: this.adeudo[index].otorganteCredito
                .nombreInstitucion,
              otorganteRFC: this.adeudo[index].otorganteCredito.rfc,
              localizacionPais: this.adeudo[index].localizacionAdeudo.pais,
              //CONCLUSION
              saldoInsolutoFechaConclusionValor: this.adeudo[index]
                .saldoInsolutoFechaConclusion.valor,
              saldoInsolutoFechaConclusionMoneda: this.adeudo[index]
                .saldoInsolutoFechaConclusion.moneda
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
           
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
              this.cambiosAdeudo[index].cambios = false;
            }
            this.enviando = false;
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo guardar la sección."
            });
            this.enviando = false;
          });
      }
    },
    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    },
    checarCambios(item, indice) {
      let index = this.cambiosAdeudo.findIndex(x => x._id == item._id);

      return this.cambiosAdeudo[indice].cambios;
      //return false;
    },
    seRealizaronCambiios(item) {
      let index = this.cambiosAdeudo.findIndex(x => x._id == item._id);
      this.cambiosAdeudo[index].cambios = true;
    },
    seleccionaValorAdquisicion(index) {
      let indice = this.formaAdquisicion.findIndex(
        x => x.clave == this.adeudo[index].formaAdquisicion.clave
      );
      this.adeudo[index].formaAdquisicion.valor = this.formaAdquisicion[
        indice
      ].valor;
    },
    seleccionaValorTipo(index) {
      let indice = this.tipoAdeudo.findIndex(
        x => x.clave == this.adeudo[index].tipoAdeudo.clave
      );
      this.adeudo[index].tipoAdeudo.valor = this.tipoAdeudo[indice].valor;
    },
    seleccionaValorMunicipio(index) {
      this.adeudo[index].domicilioMexico.municipioAlcaldia.clave = muniClave;
      let indice = this.m.findIndex(
        x =>
          x.clave === this.adeudo[index].domicilioMexico.municipioAlcaldia.clave
      );
      this.adeudo[index].domicilioMexico.municipioAlcaldia.valor = this.m[
        indice
      ].valor;
    },
    seleccionaValorParentezco(index, i) {
  
      let indice = this.parentezco.findIndex(
        x => x.clave == this.adeudo[index].transmisor[i].relacion.clave
      );
      this.adeudo[index].transmisor[i].relacion.valor = this.parentezco[
        indice
      ].valor;
    },
    seleccionaValorTitular(index, i) {
      let indice = this.titular.findIndex(
        x => x.clave == this.adeudo[index].titular[i].clave
      );
      this.adeudo[index].titular[i].valor = this.titular[indice].valor;
    },
    actualizarObservaciones() {
      this.enviando = true;

      axios
        .put(
          this.httpURL +
            "/declaraciones/V2/adeudosPasivos/" +
            this.$route.params.id +
            "/aclaracionesObservaciones",
          {
            aclaracionesObservaciones: this.adeudos.aclaracionesObservaciones
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
      
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
          }
          this.enviando = false;
          this.cambios = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo guardar la sección."
          });
          this.enviando = false;
       
        });
    },
    eliminarAdeudo(index) {
      swal({
        text: "¿Está seguro en eliminar el adeudo?",

        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/adeudosPasivos/" +
                this.$route.params.id +
                "/adeudo/" +
                this.adeudos.adeudo[index]._id,

              { headers: { token: this.sessionToken } }
            )
            .then(res => {
            
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });

                this.adeudos.adeudo.splice(index, 1);
                this.cambiosAdeudo.splice(index, 1);
                this.contador--;
              }

              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
           
            });
        }
      });
    },
    
  agregarTitular(index) {
    let indice = this.titular.findIndex(
        x => x.valor == this.tmpTitular
      );
      let nuevoTitular = {
        clave: this.titular[indice].clave,
        valor: this.tmpTitular
      };
      this.adeudo[index].titular.push(nuevoTitular);
      

      axios
        .post(
          this.httpURL +
            "/declaraciones/V2/adeudosPasivos/" +
            this.$route.params.id +
            "/adeudo/" +
            this.adeudo[index]._id +
            "/titular",

          {
            titularClave: this.titular[indice].clave,
            titularValor: this.tmpTitular
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
      
          this.banderaEditar = true;
          this.$notify({
            group: "foo",
            type: "success",
            duration: 2500,
            speed: 1000,
            text: res.data.mensaje
          });
          this.enviando = false;
        })
        .catch(error => {
          if (error.response) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: error.response.data.mensaje
            });
          } else if (error.request) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo establecer una conexión al servidor."
            });
          }
          this.enviando = false;
        });
    },
    agregarTercero(index) {
      let nuevoTercero = {
        _id: this.contadorTercero,
        tipoPersona: null,
        nombreRazonSocial: null,
        rfc: null
      };
      this.adeudo[index].tercero.push(nuevoTercero);
      this.contadorTercero++;
    },
    guardarTitular(index, i) {
      axios
        .post(
          this.httpURL +
            "/declaraciones/V2/adeudosPasivos/" +
            this.$route.params.id +
            "/adeudo/" +
            this.adeudo[index]._id +
            "/titular",

          {
            titularClave: this.adeudo[index].titular[i].clave,
            titularValor: this.adeudo[index].titular[i].valor
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
     
          this.banderaEditar = true;
          this.$notify({
            group: "foo",
            type: "success",
            duration: 2500,
            speed: 1000,
            text: res.data.mensaje
          });
          this.enviando = false;
        })
        .catch(error => {
          if (error.response) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: error.response.data.mensaje
            });
          } else if (error.request) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo establecer una conexión al servidor."
            });
          }
          this.enviando = false;
        });
    },
    tercero(id, index, i) {
      if (id < 100) {
        axios
          .post(
            this.httpURL +
              "/declaraciones/V2/adeudosPasivos/" +
              this.$route.params.id +
              "/adeudo/" +
              this.adeudo[index]._id +
              "/tercero",

            {
              tipoPersona: this.adeudo[index].tercero[i].tipoPersona,
              nombreRazonSocial: this.adeudo[index].tercero[i]
                .nombreRazonSocial,
              rfc: this.adeudo[index].tercero[i].rfc
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
          

            this.banderaEditar = true;
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
              this.adeudo[index].tercero[i]._id = res.data.tercero._id;
            }
            this.enviando = false;
          })
          .catch(error => {
            if (error.response) {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: error.response.data.mensaje
              });
            } else if (error.request) {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo establecer una conexión al servidor."
              });
            }
            this.enviando = false;
          });
      } else {
     
        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/adeudosPasivos/" +
              this.$route.params.id +
              "/adeudo/" +
              this.adeudo[index]._id +
              "/tercero/" +
              this.adeudo[index].tercero[i]._id,
            {
              tipoPersona: this.adeudo[index].tercero[i].tipoPersona,
              nombreRazonSocial: this.adeudo[index].tercero[i]
                .nombreRazonSocial,
              rfc: this.adeudo[index].tercero[i].rfc
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
          
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
              // this.cambiosAdeudo[indice].cambios = false;
            }
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo guardar la sección."
            });
            this.enviando = false;
          });
      }
    },
    eliminarTitular(index, i) {
      
      swal({
        text: "¿Está seguro en eliminar el titular?",

        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/adeudosPasivos/" +
                this.$route.params.id +
                "/adeudo/" +
                this.adeudo[index]._id +
                "/titular/" +
                this.adeudo[index].titular[index]._id,

              { headers: { token: this.sessionToken } }
            )
            .then(res => {
    
              this.adeudo[index].titular.splice(index, 1);
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });
              }
              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
          
            });
        }
      });
    },
    eliminarTercero(index, i) {
      swal({
        text: "¿Está seguro en eliminar tercero?",

        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/adeudosPasivos/" +
                this.$route.params.id +
                "/adeudo/" +
                this.adeudo[index]._id +
                "/tercero/" +
                this.adeudo[index].tercero[index]._id,
              { headers: { token: this.sessionToken } }
            )
            .then(res => {
        
              this.adeudo[index].tercero.splice(index, 1);
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });
              }
              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
             
            });
        }
      });
    }
  },
  watch: {},

  created() {
    this.adeudo = this.adeudos.adeudo;
  
    this.adeudos.adeudo.forEach(Element => {
      let objeto = { _id: Element._id, cambios: false };
      this.cambiosAdeudo.push(objeto);
      if (Element.tipoOperacion === "AGREGAR") {
        Element.tipoOperacion = "MODIFICAR";
      }
    });
  }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
